import React from 'react';

/*
Cashback icon - an open hand under a coin caught in a "money comes back" loop, drawn from
cashback.jpg.

Built as a single-colour glyph (everything paints in `currentColor`, the rupee / palm crease / cuff
button are knocked out through a mask) so it behaves exactly like the zmdi glyphs on the Sales
Statistic cards: white on the coloured circular thumb. It sizes in `em` by default, so it grows with
the thumb's font-size on hover the way a zmdi glyph does - pass `size` only to pin it in px.
*/
const CashbackIcon = ({ size = '1em', className = '', title = 'Cashback' }) => {
  // Several of these can share a page, so the mask id has to be per-instance.
  const maskId = `cashback-cut-${React.useId()}`;

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 96 96"
      fill="currentColor"
      role="img"
      aria-label={title}
      focusable="false"
    >
      <mask id={maskId} maskUnits="userSpaceOnUse" x="0" y="0" width="96" height="96">
        <rect x="0" y="0" width="96" height="96" fill="#fff" />
        {/* Rupee, cut out of the coin. The source art has a dollar - this is an INR marketplace. */}
        <g fill="none" stroke="#000" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
          <path d="M54 22H66" />
          <path d="M54 26.8H66" />
          <path d="M56.6 22c6 0 8.8 2 8.8 4.7s-2.8 4.7-8.8 4.7" />
          <path d="M56.6 31.4 65.6 39" />
        </g>
        {/* Crease where the thumb meets the palm */}
        <path d="M44 76c10-2 20-6.5 26.5-12" fill="none" stroke="#000" strokeWidth="1.8" strokeLinecap="round" />
        {/* Cuff button */}
        <circle cx="18.5" cy="84" r="3.2" fill="#000" />
      </mask>

      <g mask={`url(#${maskId})`}>
        {/* The loop: two arcs closed off by an arrowhead each */}
        <path d="M36.5 30A23.5 23.5 0 0 1 80.35 18.25" fill="none" stroke="currentColor" strokeWidth="5.5" strokeLinecap="round" />
        <path d="M83.5 30A23.5 23.5 0 0 1 39.65 41.75" fill="none" stroke="currentColor" strokeWidth="5.5" strokeLinecap="round" />
        <path d="M30.5 26.5h12l-6 11z" />
        <path d="M89.5 35.5h-12l6-10.5z" />

        {/* Coin */}
        <circle cx="60" cy="30" r="14.5" />

        {/* Palm, then the cuff at the wrist */}
        <path d="M20.5 70c2.5-6 8-10 15-11 7.3.6 14.6.8 22 .4 6.5 0 11.5 2 14.5 5.5 4.5-4.5 9.5-8 14-9.3 4-1.2 7 1.3 6.5 5.3-.6 5-5.5 10-13 14.5-11 6.5-25 11.5-38.5 13.5-4 .6-7-.5-9-3.5z" />
        <rect x="9" y="70.5" width="30" height="19" rx="4.5" transform="rotate(-40 24 80)" />
      </g>
    </svg>
  );
};

export default CashbackIcon;
